import { render, staticRenderFns } from "./docCheckPortal.vue?vue&type=template&id=bea09dce&scoped=true&"
import script from "./docCheckPortal.vue?vue&type=script&lang=js&"
export * from "./docCheckPortal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bea09dce",
  null
  
)

export default component.exports